import { Icon } from "@/assets/icons";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../Button";
import haveQuestionImg from "@/assets/i_have_question2.svg"

const Screen403: React.FC = () => {
  return (
    <div className="flex flex-col items-center gap-2 lg:h-[100vh] justify-center">
      <img src={haveQuestionImg} alt="403page" />
      <div className="text-cyan text-3xl-plus font-bold">403 Forbidden</div>
      <div className="text-cyan text-lg leading-160% font-bold">
        アクセスしようとしたページは表示できませんでした
      </div>
      <div className="text-light_secondary leading-160% font-noto-sans">
        <div>
          申し訳ありませんが、このページにアクセスする権限がありません。
        </div>
        <div>
          お困りの場合は、管理者にお問い合わせいただくか、トップページに戻ってください。
        </div>
      </div>
      <Link to="/">
        <Button
          type="button"
          variant="solid"
          color="primary"
          iconLeft={<Icon name="home" />}
          className="!h-12"
        >
          トップページへ
        </Button>
      </Link>
    </div>
  );
};

export { Screen403 };
